import { render, staticRenderFns } from "./CompletarRegistroView.vue?vue&type=template&id=1ae20b5b&scoped=true"
import script from "./CompletarRegistroView.vue?vue&type=script&lang=js"
export * from "./CompletarRegistroView.vue?vue&type=script&lang=js"
import style0 from "./CompletarRegistroView.vue?vue&type=style&index=0&id=1ae20b5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae20b5b",
  null
  
)

export default component.exports